import store from '@/store'
import { isMobileBrowser } from '@/utils/mobileAccess'

export const LoginGuard = (to, from, next) => {
	if (!isMobileBrowser() && store.getters.profile) {
		next({ name: 'home' })
		return
	}
	next()
}
